import { render, staticRenderFns } from "./TaskMoneyConfigcreditpay.vue?vue&type=template&id=5983c5ca&"
import script from "./TaskMoneyConfigcreditpay.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigcreditpay.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigcreditpay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports